import React, { useEffect, useState } from "react";
import { PageHeader } from "../components/Layout";
import { StatusBadge } from "../components/StatusBadge";
import { api } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/I18nContext";
import { RefreshCw, ArrowRight } from "lucide-react";

const EVENT_COLOR = {
  reservation_created: "text-amber-400",
  checkin: "text-emerald-400",
  checkout: "text-rose-400",
  reservation_cancelled: "text-rose-400",
  reservation_updated: "text-blue-400",
};

export default function Logs() {
  const { t } = useI18n();
  const { effectiveStructure } = useAuth();
  const [logs, setLogs] = useState([]);

  const load = () => {
    const p = effectiveStructure ? `?structure_id=${effectiveStructure}` : "";
    api.get(`/sync-logs${p}`).then((r) => setLogs(r.data));
  };
  useEffect(() => { load(); }, [effectiveStructure]);

  return (
    <div data-testid="logs-page">
      <PageHeader title={t("nav.logs")} subtitle="Booking ↔ RADIUS" action={
        <button data-testid="refresh-logs-btn" onClick={load} className="inline-flex items-center gap-2 rounded-lg bg-white/5 hover:bg-white/10 px-4 py-2.5 text-sm font-medium transition-colors"><RefreshCw className="h-4 w-4" /></button>
      } />
      <div className="rounded-xl border border-[#1F2937] bg-[#111827]">
        <div className="divide-y divide-[#1F2937]/60">
          {logs.map((l) => (
            <div key={l.id} data-testid={`log-row-${l.id}`} className="flex items-center gap-4 px-5 py-3.5 hover:bg-white/[0.02]">
              <ArrowRight className={`h-4 w-4 ${EVENT_COLOR[l.event] || "text-slate-400"}`} />
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-mono font-semibold ${EVENT_COLOR[l.event] || "text-slate-300"}`}>{l.event}</div>
                <div className="text-xs text-slate-500 truncate">{l.detail}</div>
              </div>
              <StatusBadge status={l.status === "ok" ? "accept" : "reject"} label={l.status} />
              <div className="text-xs text-slate-600 font-mono whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</div>
            </div>
          ))}
          {logs.length === 0 && <div className="px-5 py-10 text-center text-slate-500">{t("common.none")}</div>}
        </div>
      </div>
    </div>
  );
}
